import {StructuredTableColumn} from 'notebook/structured-tables/StructuredTableConstants';
import Excess from 'notebook/tables/excess';
import {Cell} from 'notebook/tables/TableConstants';

/**
 * Converts a server-provided table cell to a UI table cell.
 * Populates formulas that the server was not able to.
 *
 * @param cell Cell being converted.
 * @param columns Columns that specify default values.
 * @param i Row index.
 * @param j Column index.
 */
export default function prepareCellForTableEditable(
  cell: Cell,
  columns: Array<StructuredTableColumn>,
  i: number,
  j: number
): Cell {
  if (cell.text != null) {
    return cell;
  }
  // If no text is present in a cell, we assume the server was unable to handle translating the column
  // default into a cell value, so we do that now.
  // See benchling.workflows.lib.structured_tables:make_structured_table_cell
  const rel = Excess.tokenizer.toRelativeFormula(columns[j].defaultValue.text, {row: 0, column: j});
  const abs = Excess.tokenizer.toAbsoluteFormula(rel, {row: i, column: j});
  return {...cell, text: abs};
}
